import MainCarousel, { MainCarouselProps } from "./MainCarousel";

export { MainCarousel, MainCarouselProps };

export default MainCarousel;
